import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import Container from "../components-layout/Container"; // Container toda app
import Layout from "../Layout"; // Layout toda app
import WarningModal from "../components-modals/WarningModal"; // Modal mensajes para el usuario
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";
import Header from "../components-layout/Header";
import { AcademicCapIcon } from "@heroicons/react/24/outline";
import { fetchApi } from "../admisiones/helpers";
import { getAuth } from '../../app/authSlice'

const BusquedaSolicitudIndex = () => {

  const cookies = new Cookies();
  const url = cookies.get("__urlSchoolApi"); // url para enviar al api viene de cookies
  const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux
  const [errResponse, setErrResponse] = useState(true);

  const dispatch = useDispatch()
  const [contador, setContador] = useState(false)
  const validarUser = useSelector(state => state.auth.user)

  const urlAdmin = process.env.REACT_APP_URL_API_SEG // Para pruebas
  // const urlAdmin = process.env.REACT_APP_URL_API_PRO_SEG // Para producción 

  
  localStorage.removeItem('showAdmisiones')
  
  if ((validarUser === null || validarUser === undefined || validarUser === '' || validarUser === false) && !contador) {
    localStorage.setItem('showAdmisiones', JSON.stringify(true))
    setContador(true)
    dispatch(getAuth({
      config: {
        method: "POST", //Propiedad method, "POST", "GET", etc
        url: urlAdmin + "/seguridad/login", //URL de la API
        headers: {
          'Authorization': process.env.REACT_APP_TOKEN_API,
          'Content-ID': process.env.REACT_APP_AUDIENCIA_API,
          'Content-Type': 'application/json'
        },
        payload: JSON.stringify({ LoginId: 'publico', password: 'c@mpu$V4' }), //Propiedad payload --> datos a enviar en la solicitud http
      },
      rememberUser: false,
    }))
  }

  const user = useSelector((state) => state.auth.user);
  const userObj = JSON.parse(user);


  const [botonVisible, setBotonVisible] = useState(false);
  const [estadoIcono, setEstadoIcono] = useState('')
  const [datosSolicitud, setDatosSolicitud] = useState({
    solicitud: "",
    fecha: "",
  });

  const [modal, setModal] = useState({
    show: false,
    msg: "",
    ok: false,
  });


  const testId = async (id) => {

    const resSol = await fetchApi({
      url: url + "/utils/busquedas",
      headers: headers,
      content: {
        opcion: "ASPIRANTESGRAL_ID",
        IdSolicitud: id,
      },
    });

    if (typeof resSol === "object" && resSol.length !== 0) {
      setErrResponse(false);
      setEstadoIcono('bueno')
    } else {
      setErrResponse(true);
      setEstadoIcono('malo')
      setModal({
        show: true,
        msg: "La solicitud no es válida, intente de nuevo",
        ok: false,
      });
    }
  }

  useEffect(() => {
    if (!errResponse) {
      setBotonVisible(true);
    } else {
      setBotonVisible(false);
    }
  }, [errResponse]);

  const handleClick = (e) => {
    testId(datosSolicitud.solicitud);
  };

  const handleChange = (e) => {
    setDatosSolicitud({
      ...datosSolicitud,
      [e.target.name]: e.target.value,
    });

  };

  return (
    <>
      <WarningModal
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          )
        }
        title="Aviso"
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        <div className="mt-5 sm:mt-6 ">
          <button
            onClick={() => {
              if (modal.reload) {
                window.location.reload();
              }
              setModal((curr) => ({
                ...curr,
                show: false,
                reload: false,
              }));
            }}
            type="button"
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
          >
            Entendido
          </button>
        </div>
      </WarningModal>
      <Layout userObj={userObj} activeTab="Búsqueda de Solicitud">
        <Container height="h-full">
          <Header
            title="Búsqueda de solicitud, admisiones 2024"
            logo={AcademicCapIcon}
          />
          <div className="w-full flex flex-row justify-center">
            <div className="lg:basis-1/3 sm:basis-1/1 rounded-lg bg-primarioMira p-4 mb-4">
              <h3 className="text-white  font-semibold">
                Introduce el número de solicitud y tu fecha de nacimiento
              </h3>
              <div>
                <label className="text-white">Solicitud:</label>
                <input
                  name="solicitud"
                  onChange={(e) => handleChange(e)}
                  type="text"
                  value={datosSolicitud.solicitud}
                  className="w-full mt-1 block rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                ></input>
                <label className="text-white">Fecha de nacimiento:</label>
                <input
                  name="fecha"
                  onChange={(e) => handleChange(e)}
                  type="date"
                  value={datosSolicitud.fecha}
                  className=" w-full mt-1 block rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                ></input>
                <div className="flex flex-row">
                  {errResponse ? (
                    <>
                      <button
                        className="mt-2 relative inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                        onClick={() => handleClick()}
                      >
                        Verificar
                      </button>
                    </>
                  ) : null}
                  {botonVisible ? (
                    <a
                      href={`/campus/admisiones/${datosSolicitud.solicitud}/${datosSolicitud.fecha}`}
                      className="mt-2 relative inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                    >
                      <div className="flex m-auto">
                        <p className="ml-1">Ver solicitud</p>
                      </div>
                    </a>
                  ) : null}
                  {estadoIcono === 'malo' ?
                    <ExclamationCircleIcon
                      className="h-10 w-10 text-red-500 mt-2"
                      aria-hidden="true"
                    /> : null}
                  {estadoIcono === 'bueno' ?

                    <CheckCircleIcon
                      className="h-10 w-10 text-green-500 mt-2"
                      aria-hidden="true"
                    /> : null}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Layout>
    </>
  );
};

export default BusquedaSolicitudIndex;
